import React from 'react';
import { 
    Box, 
    Text, 
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableContainer,
} from '@chakra-ui/react';
import { payments } from '../../../utilities/dummy';

export default function BillingPaymentHistory() {
    return (
        <Box paddingTop='1'>
            <Box background={'gray.100'} padding='4'>
                <Text fontSize='lg' color='gray.600' textTransform={'capitalize'} fontWeight={'semibold'}>
                   Payment History
                </Text>
            </Box>
            <TableContainer>
                <Table marginTop={'4'} colorScheme='gray'>
                    <Thead>
                        <Tr>
                            <Th>Payment Method</Th>
                            <Th>Price</Th>
                            <Th>Duration</Th>
                            <Th>Billing Date</Th>
                        </Tr>
                    </Thead>
                    <Tbody>
                        {payments.map((item) => (
                            <Tr>
                                <Td>{item.type}****{item.masked}</Td>
                                <Td>{item.currency} {item.price}</Td>
                                <Td>{item.duration}</Td>
                                <Td>{item.dateBilled}</Td>
                            </Tr>
                        ))}
                    </Tbody>
                </Table>
            </TableContainer>
        </Box>
    )
}